var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient"},_vm._l((_vm.todos),function(todo,index){return _c('gradient-color',{key:todo.name,attrs:{"colors":todo.colors,"active":index <= _vm.currentIndex}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }